// Copyright 2026. WebPros International GmbH. All rights reserved.

// Shared column widths used by both the outer activity table and inner entity table.
export const COLUMN_WIDTHS = {
    id: '60px',
    computeResource: '200px',
    status: '200px',
    startedAt: '210px',
    duration: '120px',
    processes: '120px',
    destinationCr: '200px',
    failoverDomain: '180px',
    actions: '50px',
} as const;
